"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var helpers_1 = require("../helpers");

var fallback_1 = require("./fallback");

function getBrowerCrypto() {
  var _a, _b;

  return ((_a = global) === null || _a === void 0 ? void 0 : _a.crypto) || ((_b = global) === null || _b === void 0 ? void 0 : _b.msCrypto) || {};
}

exports.getBrowerCrypto = getBrowerCrypto;

function getSubtleCrypto() {
  var browserCrypto = getBrowerCrypto();
  return browserCrypto.subtle || browserCrypto.webkitSubtle;
}

exports.getSubtleCrypto = getSubtleCrypto;

function browserRandomBytes(length) {
  var browserCrypto = getBrowerCrypto();

  if (typeof browserCrypto.getRandomValues !== 'undefined') {
    return helpers_1.arrayToBuffer(browserCrypto.getRandomValues(new Uint8Array(length)));
  }

  return fallback_1.fallbackRandomBytes(length);
}

exports.browserRandomBytes = browserRandomBytes;

function browserImportKey(buffer) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants_1.AES_BROWSER_ALGO;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var subtle, algo, ops, cryptoKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            subtle = getSubtleCrypto();
            algo = type === constants_1.AES_BROWSER_ALGO ? {
              length: constants_1.AES_LENGTH,
              name: constants_1.AES_BROWSER_ALGO
            } : {
              hash: {
                name: constants_1.HMAC_BROWSER_ALGO
              },
              name: constants_1.HMAC_BROWSER
            };
            ops = type === constants_1.AES_BROWSER_ALGO ? [constants_1.ENCRYPT_OP, constants_1.DECRYPT_OP] : [constants_1.SIGN_OP, constants_1.VERIFY_OP];
            _context.next = 5;
            return subtle.importKey('raw', buffer, algo, true, ops);

          case 5:
            cryptoKey = _context.sent;
            return _context.abrupt("return", cryptoKey);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.browserImportKey = browserImportKey;

function browserAesEncrypt(iv, key, data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var subtle, cryptoKey, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context2.next = 3;
            return browserImportKey(key, constants_1.AES_BROWSER_ALGO);

          case 3:
            cryptoKey = _context2.sent;
            _context2.next = 6;
            return subtle.encrypt({
              iv,
              name: constants_1.AES_BROWSER_ALGO
            }, cryptoKey, data);

          case 6:
            result = _context2.sent;
            return _context2.abrupt("return", Buffer.from(result));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.browserAesEncrypt = browserAesEncrypt;

function browserAesDecrypt(iv, key, data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var subtle, cryptoKey, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context3.next = 3;
            return browserImportKey(key, constants_1.AES_BROWSER_ALGO);

          case 3:
            cryptoKey = _context3.sent;
            _context3.next = 6;
            return subtle.decrypt({
              iv,
              name: constants_1.AES_BROWSER_ALGO
            }, cryptoKey, data);

          case 6:
            result = _context3.sent;
            return _context3.abrupt("return", Buffer.from(result));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.browserAesDecrypt = browserAesDecrypt;

function browserHmacSha256Sign(key, data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var subtle, cryptoKey, signature;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context4.next = 3;
            return browserImportKey(key, constants_1.HMAC_BROWSER);

          case 3:
            cryptoKey = _context4.sent;
            _context4.next = 6;
            return subtle.sign({
              length: constants_1.HMAC_LENGTH,
              name: constants_1.HMAC_BROWSER
            }, cryptoKey, data);

          case 6:
            signature = _context4.sent;
            return _context4.abrupt("return", Buffer.from(signature));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.browserHmacSha256Sign = browserHmacSha256Sign;

function browserHmacSha512Sign(key, data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var subtle, cryptoKey, signature;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context5.next = 3;
            return browserImportKey(key, constants_1.HMAC_BROWSER);

          case 3:
            cryptoKey = _context5.sent;
            _context5.next = 6;
            return subtle.sign({
              length: constants_1.LENGTH_512,
              name: constants_1.HMAC_BROWSER
            }, cryptoKey, data);

          case 6:
            signature = _context5.sent;
            return _context5.abrupt("return", Buffer.from(signature));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

exports.browserHmacSha512Sign = browserHmacSha512Sign;

function browserSha256(data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var subtle, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context6.next = 3;
            return subtle.digest({
              name: constants_1.SHA256_BROWSER_ALGO
            }, data);

          case 3:
            result = _context6.sent;
            return _context6.abrupt("return", Buffer.from(result));

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

exports.browserSha256 = browserSha256;

function browserSha512(data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var subtle, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            subtle = getSubtleCrypto();
            _context7.next = 3;
            return subtle.digest({
              name: constants_1.SHA512_BROWSER_ALGO
            }, data);

          case 3:
            result = _context7.sent;
            return _context7.abrupt("return", Buffer.from(result));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
}

exports.browserSha512 = browserSha512;